module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-wrapper clearfix"
  }, [_c('hamburger', {
    on: {
      "hamburger": _vm.hamburgerClicked
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header-img-container col-xs-12 hidden-sm hidden-md hidden-lg"
  }, [_c('img', {
    staticClass: "header-img",
    attrs: {
      "src": _vm.exportImagePath(_vm.content.mobileImage),
      "alt": "The Shape of Water",
      "width": "100%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "header-img-container hidden-xs col-sm-12 col-md-12 col-lg-12"
  }, [_c('img', {
    staticClass: "header-img",
    attrs: {
      "src": _vm.exportImagePath(_vm.content.image),
      "alt": "The Shape of Water",
      "width": "100%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "scroller-anchor"
  }), _vm._v(" "), _c('div', {
    staticClass: "category-title"
  }, [_c('div', {
    staticClass: "scroller-target"
  }, [(_vm.content.superHeader) ? _c('h3', [_vm._v(_vm._s(_vm.content.superHeader))]) : _vm._e(), _vm._v(" "), (_vm.content.header) ? _c('h1', [_vm._v(_vm._s(_vm.content.header))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "category-crew"
  }, [(_vm.content.crewTitle) ? _c('h3', [_vm._v(_vm._s(_vm.content.crewTitle))]) : _vm._e(), _vm._v(" "), _c('table', _vm._l((_vm.content.subHeader), function(subheader) {
    return _c('tr', {
      domProps: {
        "innerHTML": _vm._s(subheader)
      }
    })
  }))])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6602f994", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6602f994","transformToRequire":{"video":["src","poster"],"source":"src","object":"data","iframe":"src","embed":"src","a":"href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hero.vue
// module id = 409
// module chunks = 0